// import React, { useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { useAuth } from "../../context/AuthContext";

// // const API = "http://localhost:5001/api/padre/excusas";
// const API = "http://3.236.217.225:5001/api/padre/excusas";

// const PadreExcusas = () => {
//   const { token } = useAuth();

//   const axiosAuth = axios.create({
//     baseURL: API,
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });

//   const [excusas, setExcusas] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const [form, setForm] = useState({
//     documento_estudiante: "",
//     motivo: "",
//     fecha_inicio: "",
//     fecha_fin: "",
//   });

//   /* ================= CARGAR EXCUSAS ================= */

//   const cargarExcusas = useCallback(async () => {
//     if (!token) return;

//     try {
//       setLoading(true);
//       setError("");

//       const res = await axiosAuth.get("/");
//       setExcusas(res.data || []);
//     } catch (err) {
//       console.error("❌ Error cargando excusas:", err);
//       setError("No se pudieron cargar las excusas");
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   useEffect(() => {
//     cargarExcusas();
//   }, [cargarExcusas]);

//   /* ================= ENVIAR EXCUSA ================= */

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       setError("");

//       await axiosAuth.post("/", form);

//       setForm({
//         documento_estudiante: "",
//         motivo: "",
//         fecha_inicio: "",
//         fecha_fin: "",
//       });

//       cargarExcusas();
//     } catch (err) {
//       console.error("❌ Error enviando excusa:", err);
//       setError("Error al enviar la excusa");
//     }
//   };

//   /* ================= UI ================= */

//   return (
//     <div className="card">
//       <h2>📄 Mis Excusas</h2>

//       {error && <p style={{ color: "red" }}>{error}</p>}

//       {/* ================= FORMULARIO ================= */}
//       <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
//         <input
//           type="text"
//           placeholder="Documento del estudiante"
//           value={form.documento_estudiante}
//           onChange={(e) =>
//             setForm({ ...form, documento_estudiante: e.target.value })
//           }
//           required
//         />

//         <input
//           type="date"
//           value={form.fecha_inicio}
//           onChange={(e) =>
//             setForm({ ...form, fecha_inicio: e.target.value })
//           }
//           required
//         />

//         <input
//           type="date"
//           value={form.fecha_fin}
//           onChange={(e) =>
//             setForm({ ...form, fecha_fin: e.target.value })
//           }
//           required
//         />

//         <textarea
//           placeholder="Motivo de la excusa"
//           value={form.motivo}
//           onChange={(e) =>
//             setForm({ ...form, motivo: e.target.value })
//           }
//           required
//         />

//         <button type="submit">Enviar Excusa</button>
//       </form>

//       <hr />

//       {/* ================= LISTADO ================= */}

//       {loading && <p>Cargando excusas...</p>}

//       {!loading && excusas.length === 0 && (
//         <p>No has enviado excusas aún.</p>
//       )}

//       {excusas.map((e) => (
//         <div
//           key={e.id}
//           className="excusa-card"
//           style={{
//             border: "1px solid #ddd",
//             padding: "10px",
//             marginBottom: "10px",
//             borderRadius: "8px",
//           }}
//         >
//           <h4>
//             {e.nombres_estudiante} {e.apellidos_estudiante}
//           </h4>

//           <p>
//             <b>Desde:</b> {e.fecha_inicio} <br />
//             <b>Hasta:</b> {e.fecha_fin}
//           </p>

//           <p>
//             <b>Motivo:</b> {e.motivo}
//           </p>

//           <p>
//             <b>Estado:</b>{" "}
//             {e.estado === "pendiente" && "🟡 Pendiente"}
//             {e.estado === "aprobada" && "🟢 Aprobada"}
//             {e.estado === "rechazada" && "🔴 Rechazada"}
//           </p>

//           {e.respuesta && (
//             <p>
//               <b>Respuesta institución:</b> {e.respuesta}
//             </p>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default PadreExcusas;


///

import React, { useEffect, useState, useCallback } from "react";
// 1. IMPORTAMOS LA INSTANCIA CONFIGURADA
import axios from "../../api/axiosAuth"; 
import { useAuth } from "../../context/AuthContext";
import "../../style/excusasRector.css"; // Reutilizamos estilos o usa el tuyo específico

const PadreExcusas = () => {
  const { token } = useAuth();

  const [excusas, setExcusas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    documento_estudiante: "",
    motivo: "",
    fecha_inicio: "",
    fecha_fin: "",
  });

  /* ================= CARGAR EXCUSAS ================= */
  const cargarExcusas = useCallback(async () => {
    if (!token) return;

    try {
      setLoading(true);
      setError("");
      // 2. CORREGIDO: Ruta relativa. axiosAuth ya tiene la baseURL de AWS
      const res = await axios.get("/padre/excusas");
      setExcusas(res.data || []);
    } catch (err) {
      console.error("❌ Error cargando excusas:", err);
      setError("No se pudieron cargar las excusas enviadas.");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    cargarExcusas();
  }, [cargarExcusas]);

  /* ================= ENVIAR EXCUSA ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      // 3. CORREGIDO: Ruta relativa para POST
      await axios.post("/padre/excusas", form);

      // Limpiar formulario tras éxito
      setForm({
        documento_estudiante: "",
        motivo: "",
        fecha_inicio: "",
        fecha_fin: "",
      });

      alert("✅ Excusa enviada correctamente");
      cargarExcusas(); // Recargar el listado
    } catch (err) {
      console.error("❌ Error enviando excusa:", err);
      setError("Error al enviar la excusa. Verifique los datos.");
    }
  };

  /* ================= UI ================= */
  return (
    <div className="excusa-list">
      <h2>📄 Gestión de Excusas</h2>

      {error && <p className="error-msg" style={{ color: "#e11d48", fontWeight: "bold" }}>{error}</p>}

      {/* ================= FORMULARIO ================= */}
      <section className="form-section" style={{ background: "#f8fafc", padding: "20px", borderRadius: "12px", marginBottom: "30px" }}>
        <h3>Solicitar Nueva Excusa</h3>
        <form onSubmit={handleSubmit} className="filtros" style={{ display: "grid", gap: "10px" }}>
          <input
            type="text"
            placeholder="Documento del estudiante"
            value={form.documento_estudiante}
            onChange={(e) => setForm({ ...form, documento_estudiante: e.target.value })}
            required
          />
          
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ flex: 1 }}>
              <label><small>Desde:</small></label>
              <input
                type="date"
                value={form.fecha_inicio}
                onChange={(e) => setForm({ ...form, fecha_inicio: e.target.value })}
                required
              />
            </div>
            <div style={{ flex: 1 }}>
              <label><small>Hasta:</small></label>
              <input
                type="date"
                value={form.fecha_fin}
                onChange={(e) => setForm({ ...form, fecha_fin: e.target.value })}
                required
              />
            </div>
          </div>

          <textarea
            placeholder="Describa el motivo de la inasistencia..."
            value={form.motivo}
            onChange={(e) => setForm({ ...form, motivo: e.target.value })}
            style={{ padding: "10px", borderRadius: "8px", border: "1px solid #cbd5e1", minHeight: "80px" }}
            required
          />

          <button type="submit" className="btn-buscar">🚀 Enviar Solicitud</button>
        </form>
      </section>

      <hr />

      {/* ================= LISTADO ================= */}
      <h3>Historial de Solicitudes</h3>
      {loading && <p>⏳ Actualizando listado...</p>}

      {!loading && excusas.length === 0 && (
        <p className="no-data">Aún no has registrado ninguna excusa.</p>
      )}

      <div className="grid-excusas">
        {excusas.map((e) => (
          <div key={e.id} className="padre-card" style={{ marginBottom: "15px", borderLeft: `5px solid ${e.estado === 'aprobada' ? '#22c55e' : e.estado === 'rechazada' ? '#ef4444' : '#f59e0b'}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <h4>{e.nombres_estudiante} {e.apellidos_estudiante}</h4>
              <span className={`estado ${e.estado}`}>
                {e.estado.toUpperCase()}
              </span>
            </div>

            <p style={{ margin: "5px 0" }}>
              📅 <strong>Periodo:</strong> {new Date(e.fecha_inicio).toLocaleDateString()} — {new Date(e.fecha_fin).toLocaleDateString()}
            </p>

            <p><strong>Motivo:</strong> {e.motivo}</p>

            {e.respuesta && (
              <div style={{ marginTop: "10px", padding: "10px", background: "#f1f5f9", borderRadius: "6px" }}>
                <strong>💬 Respuesta Institucional:</strong>
                <p style={{ margin: 0, fontStyle: "italic" }}>{e.respuesta}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PadreExcusas;